import { render, staticRenderFns } from "./AppSingleItemAnswer.vue?vue&type=template&id=b77e3e44&scoped=true"
import script from "./AppSingleItemAnswer.vue?vue&type=script&lang=ts"
export * from "./AppSingleItemAnswer.vue?vue&type=script&lang=ts"
import style0 from "./AppSingleItemAnswer.vue?vue&type=style&index=0&id=b77e3e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77e3e44",
  null
  
)

export default component.exports